import {
  BankingSignupModalContext,
  type OpenBankingSignupFlow,
} from 'contexts/BankingSignupModal/BankingSignupModalContext';
import { useContext } from 'react';

export default function useGlobalBankingSignupModal(): OpenBankingSignupFlow {
  const openSignupFlow = useContext(BankingSignupModalContext);

  if (!openSignupFlow) {
    throw new Error(
      'useGlobalBankingSignupModal must be used within BankingSignupModalProvider',
    );
  }

  return openSignupFlow;
}
